import {
  IExhibitorOnboardingTranslations,
  IExhibitorSessions,
  IExhibitorInteractionsTranslations,
  IExhibitorSettingsTranslations,
  IExhibitorSidebar,
  IExhibitorsDashboardTranslations,
  IExhibitorProducsTranslations,
  IExhibitorProductInteractions,
  IExhibitorProfile,
  IExhibitorTickets,
  IExhibitorVisitors,
  IExhibitorExports,
  IExhibitorTeam,
  IExhibitorsBookletTranslations,
} from '.';

const booklet: IExhibitorsBookletTranslations = {
  cta_copy: 'Exemple de brochure',
  success_message: 'Une brochure va vous être envoyé par email avec tous les exposants.',
  no_booklet_message: "Il n'y a pas de brochure a envoyer.",
  modal_title: 'Exemple de brochure',
  modal_subtitle: 'Un exemple de brochure va être envoyé à',
  send_booklet: 'Envoyer',
};

const dashboard: IExhibitorsDashboardTranslations = {
  title: 'Bonjour',
  subtitle: "Bienvenue dans l'application de gestion d'événements beamian",
  ticket_codes_title: 'Ticket codes',
  ticket_codes_subtitle: 'Copy and send these codes to whoever you want to invite!',
  usable_tickets: 'Unused tickets',
  general_information_title: 'Tes indicateurs de performance',
  general_information_subtitle: 'Comment les candidats interagissent avec toi',
  sessions_subtitle: 'Dernier nombre de sessions créées et inscriptions',
  sessions_title: 'Your registration numbers',
  booked_as_favorite: 'Marcações como favorito',
  upcoming_sessions: 'Prochaines séances',
  exhibitor_pending_title: 'Your exhibitor has not been approved',
  exhibitor_pending_text: 'Please wait until the event manager aproves your exhibitor',
};

const exports: IExhibitorExports = {
  title: 'Exportations',
  subtitle: 'Gérez et téléchargez vos exportations',
  export_contacts: 'Exporter des contacts',
  export_contacts_subtitle:
    "Sélectionnez les informations sur les visiteurs à inclure dans l'exportation :",
};

const team: IExhibitorTeam = {
  title: 'Équipe',
  subtitle: "Gérer les autres responsables d'exposant",
  title_empty: "Vos responsables d'exposant apparaitront ici !",
  subtitle_empty: "Ajouter de nouveaux responsables d'exposant",
  tab_1: "Responsables d'exposant",
  tab_2: 'Invitations en attente',
  exhibitor_mnanagers_left: "Responsables d'exposant restants.",
  resend_registration_email: "Renvoyer l'email d'inscription",
  resend_invitation: "Renvoyer l'invitation",
  confirm_removing_exhibitor_manager: "Voulez-vous vraiment supprimer ce responsable d'exposant ?",
  confirm_removing_exhibitor_manager_invite:
    "Voulez-vous vraiment annuler cette invitation d'un responsable d'exposant ?",
  email_input_title: 'Adresse email',
  email_input_placeholder: 'johndoe@gmail.com',
  invite_exists: 'Ce contact a déjà été invité.',
};

const visitors: IExhibitorVisitors = {
  title: 'Visitors',
  subtitle: 'See visitor information, invite visitor to private sessions',
  assign_packages: 'Assign packages',
  visitor_information: 'Visitor information',
  assign_step_1: 'Find an existing visitor or register a new one',
  assign_step_2: 'Register new visitor',
  assign_step_3: 'Add packages to visitor',
  assign_step_4: 'All done!',
  assign_step_5: "You can't assign any more packages",
  out_of_packages: 'You are out of packages to assign.',
  package_name: 'Package name',
  package_assigned_successfuly: 'Package assigned successfuly!',
  assign_another: 'Assign another',
  invite_private_session: 'Invitar a una sesión privada',
  user_not_registered: 'Este usuario no está registrado para ninguna sesión de su expositor.',
  enter_note_placeholder: 'Entrez votre note',
  empty_list_title: "Vos contacts s'afficheront ici",
  empty_list_subtitle: "Partagez votre page d'exposant pour obtenir plus d'interactions !",
  filters: {
    registered_for_sessions: 'Inscrit aux sessions',
    interacted_with_exhibitor: "Interaction avec l'exposant",
    interacted_with_product: 'Interaction avec le produit',
    invited_by_you: 'Invité par vous',
    redeemed_code: 'A utilisé un de vos codes',
  },
  sessions: {
    export: 'Exporter',
    export_sessions: 'Exporter des sessions',
    message_201:
      "La création du fichier d'exportation a commencé. Veuillez réessayer dans un instant",
    message_204:
      "Le fichier d'exportation est en cours de création. Veuillez réessayer dans un instant",
    subtitle:
      "Sélectionnez des informations supplémentaires sur les visiteurs à inclure dans l'exportation :",
  },
};

const tickets: IExhibitorTickets = {
  title: 'Atribuições',
  subtitle: 'Bilhetes atribuidos a visitantes',
  new_assignment: 'Nova atribuição',
  assignee_name: 'Nome do recebedor/a',
  assignee_email: 'Email do recebedor/a',
  visitor_name: 'Nome do visitante',
  visitor_email: 'Email do visitante',
  ticket: 'Bilhete',
  ticket_type_title: 'Bilhetes',
  ticket_type_subtitle: 'Atribua bilhetes a visitantes',
  assign_title: 'Assign ticket to a visitor',
  assign: 'Assign',
  ticket_success: 'Ticket assigned successfuly!',
};

const sidebar: IExhibitorSidebar = {
  title: 'Exposition',
  home: 'Home',
  exhibitor_interactions: "Intéressé par l'exposant",
  exhibitor_sessions: 'Mon agenda',
  interactions: 'Visiteurs',
  sessions: 'Séances',
  settings: 'Profil',
  products: 'Offres',
  product_interactions: 'Intéressé par les offres',
  tickets: 'Tickets',
  exports: 'Exports',
  team: 'Équipe',
};

const settings: IExhibitorSettingsTranslations = {
  title: 'Paramètres de l’exposant',
  basicInfo: 'Informations de base',
  save: 'Sauvegarder',
  additionalInfo: 'Informations complémentaires',
  formError: 'Aucune information trouvée, formulaire non disponible.',
};

const products: IExhibitorProducsTranslations = {
  title: 'Offres',
  subtitle: 'Créer, modifier et supprimer des offres',
  no_products: 'Aucune offre disponible',
  new_product: 'Nouvelle offre',
  create_new_product: 'Créer',
  edit_product: "Modifier l'offre",
  delete_confirm: "Êtes-vous sûr de vouloir supprimer cette offre d'emploi ?",
  interactions_exist_cannot_delete: 'Fait déjà l’objet d’interactions. Ne peut pas être supprimée.',
  search_placeholder: ' Tapez ce que vous souhaitez rechercher dans la liste des offres',
  you_have: 'You have',
  products_left: 'products left.',
  inputs: {
    name: 'Nom',
  },
  form_not_ready:
    "Le formulaire de produit n'a pas encore été créé par votre gestionnaire d'événements. Veuillez réessayer plus tard.",
};

const interactions: IExhibitorInteractionsTranslations = {
  title: "Visiteurs intéressés par l'exposant",
  subtitle: "Consulter la liste des visiteurs intéressés par l'exposant",
  download: 'Télécharger',
  noInteractions: 'Cet exposant ne présente aucune interaction.',
  interaction: {
    editComment: 'Modifier un commentaire',
    saveComment: 'Enregistrer un commentaire',
    checkIn: 'Enregistrement',
  },
  search_placeholder: 'Tapez ce que vous souhaitez rechercher dans la liste de contacts',
};

const onboarding: IExhibitorOnboardingTranslations = {
  step_authentication: 'Authentification',
  step_basicInfo: 'Informations de base',
  step_additionalInfo: 'Informations complémentaires',
  step_review: 'Revue',
  step_done: 'Terminé !',
  convert_titles: {
    logo: 'Logo',
    profile_pic: 'Image de profil',
    embedded: 'vidéo Youtube',
    meeting_room: 'Activer la salle de réunion virtuelle',
  },
  login: {
    title: "Vous êtes sur le point d'inscrire votre exposant",
    subtitle: 'Première connexion ou inscription',
    message:
      'Pour enregistrer votre exposant, vous devez vous connecter ou créer un nouveau compte beamian.',
    exhibitor_manager_name: 'Saisir le nom de l’exposant responsable',
    exhibitor_manager_email: 'Saisir l’adresse électronique de l’exposant responsable',
  },
  basicInformation: {
    title: 'Parlez-nous de votre exposant',
    warning:
      'Les informations fournies seront utilisées pour créer le livret et un profil que les visiteurs pourront voir.',
    createExhibitor: 'Créer un exposant',
    exhibitor_name: "Nom de l'exposant",
    exhibitor_name_placeholder: 'Saisir le nom de votre exposant (entreprise)',
    modal: {
      title: 'Attention',
      subtitle: "Si vous souhaitez gérer votre exposant, veuillez d'abord vous connecter.",
      skip: 'Sauter',
      createAccount: 'Créer un compte',
      login: 'Connexion',
    },
  },
  managedFields: {
    title: 'Informations complémentaires',
    crop_image: "Recadrer l'image",
    crop_again: 'Retour au recadrage',
  },
  review: {
    title: 'Vérifier les informations',
    name: 'Nom',
  },
  completed: {
    title: 'Exposant créé !',
    subtitle: 'Votre exposant est prêt. Merci pour votre soumission !',
    manage: 'Gérer',
  },
  back: 'Retour',
  next: 'Suivant',
  submit: 'Soumettre',
};

const sessions: IExhibitorSessions = {
  title: 'Séances',
  subtitle: 'Créer, modifier et supprimer des séances',
  start_date: 'Commence à :',
  end_date: 'Se termine à :',
  join_meeting: 'Rejoindre la séance',
  meeting_url: 'URL de la réunion :',
  description: 'Description :',
  new_session: 'Nouvelle séance',
  new_spacer: 'Nouvel onglet',
  edit_session: 'Modifier la séance',
  edit_spacer: "Modifier l'onglet",
  register: "S'inscrire",
  invited_users: 'Invité',
  inputs: {
    name: 'Nom',
    name_placeholder: 'Entrer le nom de la séance',
    start_date: 'Date de début',
    start_date_placeholder: 'Entrer la date de début de la séance',
    end_date: 'Date de fin',
    end_date_placeholder: 'Entrer la date de fin de la séance',
    color: 'Date de couleur',
    color_placeholder: 'Entrer la couleur de la session',
    widget_block: 'Bloc de widgets',
    widget_block_placeholder: 'Entrer le code html',
    widget_block_message:
      "Ce texte ou html apparaîtra dans la page de la session sous la vidéo ou l'image principale et au-dessus de la description .",
    description: 'Description',
    description_placeholder: 'Entrer la description de la séance',
    entrance_capacity: "Capacité d'entrée",
    entrance_capacity_placeholder: "Entrer la capacité d'entrée",
    registration_capacity: "Capacité d'inscription",
    registration_capacity_placeholder: "Entrer la capacité d'inscription",
    external_link: 'URL de la réunion',
    external_link_placeholder: "Saisir l'URL de la réunion",
    external_link_warning_message:
      'Veuillez laisser ce champ vide si vous souhaitez que beamian crée une salle de réunion en votre nom.',
    order: 'Ordre',
    order_placeholder: "Entrer l'ordre des séances",
    private_session: 'Séance privée',
    streaming_link: 'URL de transmisión',
    streaming_link_placeholder: 'Ingresar URL de transmisión',
    streaming_link_warning_message:
      'Esta transmisión estará disponible para todos los usuarios, incluidos los que no están registrados para esta sesión.',
    image: 'Imagen',
    image_placeholder: 'Sube la imagen de tu sesión',
    hide: 'Cacher',
    hide_on_calendar: 'Esconderse en el calendario',
    hide_remaining_capacity: 'Masquer la capacité restante',
    allow_exited_users_entering: 'Les visiteurs peuvent rentrer',
    is_daily_checkin: 'Work as a daily checkin session',
    is_daily_checkin_help_text:
      'This session will be available for in-person access control in a specific date',
    use_default_language_only: 'Utilizar idioma padrão do evento',
    display_counter:
      "Affichage d'un compteur avec le nombre d'utilisateurs qui regardent le stream",
    display_counter_placeholder: 'Uniquement applicable aux streams Amazon IVS.',
    location_image_placeholder: 'Upload your location image',
  },
  session_label: 'Séance',
  select_session: 'Sélectionner une séance',
  no_private_sessions: "Il n'y a pas de séances d’exposant",
  private_session_warning:
    "Créer une séance privée pour inviter des candidats spécifiques à une réunion. S'il s'agit d'une séance publique, tout candidat pourra la voir et s'y inscrire.",
  enable_mod_chat: 'Permettre conversation de modération',
  enable_chat: 'Permettre conversation',
  embed_meeting: 'Incorporer vidéo de réunion',
  embed_meeting_detail:
    "Si vous désélectionnez cette option, le lien de la réunion s'ouvrira dans un nouvel onglet",
  you_have: 'You have',
  sessions_left: 'sessions left',
  new_stage: 'New Stage',
  add_stage: 'Add Stage',
  managers: 'Responsables',
};

const productInteractions: IExhibitorProductInteractions = {
  title: 'Visiteurs intéressés par les offres',
  subtitle:
    'Consultez la liste des visiteurs intéressés par vos offres et planifiez des rendez-vous',
  product_name: 'Offre',
  all_products: 'All products',
  interaction_name: 'Nom du visiteur',
  application: 'Informations de contact',
  invite_to_session: 'Planifier une réunion',
  send_invite: 'Envoyer une invitation',
  user_already_registered: 'Cet utilisateur est déjà inscrit à cette séance',
  publish_warning: 'En publiant ce formulaire, les informations seront visibles pour les visiteurs',
  invitation_sent: 'Invitation envoyée avec succès',
  search_placeholder: 'Tapez ce que vous souhaitez rechercher dans la liste de contacts',
  empty_list_title: 'Vos interactions avec le produit apparaîtront ici',
  empty_list_subtitle: "Partagez votre page d'exposant pour obtenir plus d'interactions!",
};

const profile: IExhibitorProfile = {
  exhibitor_information: 'Informations sur l’exposant',
  products: 'Offres',
};

export default {
  booklet,
  dashboard,
  settings,
  interactions,
  onboarding,
  sidebar,
  sessions,
  products,
  productInteractions,
  exports,
  visitors,
  profile,
  tickets,
  team,
};
